import { format } from 'date-fns';

import { DateFormat } from 'core/global.enum';
import { Table } from 'ui/table/Table';

import { CurrentPresenceOwnersTableRowProps } from './CurrentPresenceOwnersTableRow.types';

export const CurrentPresenceOwnersTableRow = ({ owner }: CurrentPresenceOwnersTableRowProps) => {
  return (
    <>
      <Table.RowItem text={owner.strefa.nazwa} />

      <Table.RowItem>{format(new Date(owner.dataWejscia), `${DateFormat.DATE}, ${DateFormat.TIME}`)}</Table.RowItem>

      <Table.RowItem text={`${owner.nazwisko} ${owner.imie}`} />

      <Table.RowItem>{owner.nrEwidencyjny}</Table.RowItem>

      <Table.RowCellsItem cells={owner.komorki} />
    </>
  );
};
